import { message } from "antd";

export function copyToClipboard(text, successMsg = "Copied to clipboard!") {
    navigator.clipboard.writeText(text).then(r =>
        message.success(successMsg)
    )
}